export const EMERGENCY_CONTACT_OPTIONS = {
  RELATIONSHIP_TO_PATIENT: "Patient.EmergencyContact.RelationshipToPatient",
  FULL_NAME: "Patient.EmergencyContact.FullName",
  FIRST_NAME: "Patient.EmergencyContact.FirstName",
  LAST_NAME: "Patient.EmergencyContact.LastName",
  PHONE_NUMBER: "Patient.EmergencyContact.PhoneNumber",
  FULL_ADDRESS: "Patient.EmergencyContact.FullAddress",
  STREET_ADDRESS_LINE1: "Patient.EmergencyContact.StreetAddressLine1",
  STREET_ADDRESS_LINE2: "Patient.EmergencyContact.StreetAddressLine2",
  CITY: "Patient.EmergencyContact.City",
  STATE: "Patient.EmergencyContact.State",
  ZIP_CODE: "Patient.EmergencyContact.ZIPCode",
};
